import service from '@/request/api'; // 导入api接口
import { Toast, Dialog } from 'vant';
import router from '../../../router';

export default {
  namespaced: true,
  state: {
    orderId: localStorage.getItem('orderId'),
    plat_name: '',
    contractInfoObj: {
      lend_acct_no: '',
      plat_name: '',
      loan_purpose_cn: '',
      loan_amt_cn: '',
      loan_amt: 0,
      repay_sp_term: '',
      loan_start_date: '',
      loan_end_date: '',
      exec_rate: '',
      repay_type_name: '',
      repay_bank_name: '',
      repay_acct_no: '',
      repay_acct_name: '',
      usableAmount: '',
      securityRate: '',
      securityAmount: '',
      isSecondAcct: false,
      IsloadingBox: false,
    },
    creditContractObj: {},
    bankCard: '',
    getBorrowerinfoObj: {},
    addOkCalculationObj: {
      repay_inter_now: '',
      repay_princ_now: '',
      repay_date: '',
      repay_amt_now: '',
      rest_amt: '',
    },
    amount: null,
    drawId: localStorage.getItem('drawId') || '',
    isBtn: false,
  },
  mutations: {
    updateForm(state, obj) {
      // eslint-disable-next-line
      for (let key in obj) {
        state[key] = obj[key];
      }
    },
  },
  actions: {
    // 初始化借款合同页面
    contDrawGenerateSpdb(context) {
      const { orderId } = context.state;
      const data = service.OtherPage.contDrawGenerateSpdb({
        orderId,
      });
      data
        .then((res) => {
          if (res.success) {
            context.commit('updateForm', {
              contractInfoObj: res.data,
            });
          } else {
            Toast(res.returnMessage);
          }
        })
        .catch(() => {
          Toast('小望已离开地球，请稍后重试！');
        });
    },
    // 确认签署借款合同页面
    signDrawGenerateSpdb(context) {
      const { orderId } = context.state;
      context.commit('updateForm', {
        contractInfoObj: { ...context.state.contractInfoObj, IsloadingBox: true },
      });
      const data = service.OtherPage.signDrawGenerateSpdb({
        orderId,
      });
      data
        .then((res) => {
          context.commit('updateForm', {
            contractInfoObj: { ...context.state.contractInfoObj, IsloadingBox: false },
          });
          if (res.success) {
            router.push('/supermarket/v2/withdrawalSuccessful');
          } else if (
            !res.success
            && (res.returnCode === 'EDC0002' || res.returnCode === 'EGG0044')
          ) {
            const isText = '签署';
            router.push(
              `/supermarket/v2/ToIntoFail?ret_msg=${res.returnMessage}&retCode=${res.returnCode}&isText=${isText}&orderId=${orderId}`,
            );
          } else {
            Toast(res.returnMessage);
          }
        })
        .catch(() => {
          Toast('小望已离开地球，请稍后重试！');
        });
    },

    nextJumpPage(context) {
      const { orderId } = context.state;
      service.CommonForms.nextJumpPageServer({
        orderId: orderId || localStorage.getItem('orderId') || '',
      }).then((res) => {
        if (res.success) {
          if (res.data) {
            window.location.href = res.data;
          }
        } else {
          Toast(res.returnMessage);
        }
      });
    },
    // 后台接口统一控制跳转 - 签署合同、上传营业执照等 (TODO-YXF 可替换service.CommonForms.jumpThirdServe)
    async jumpCurrPageServer(context) {
      try {
        const { orderId } = context.state;
        const { data, returnCode, returnMessage } = await service.PublicPage.jumpCurrPage({
          orderId,
        });
        if (data) {
          window.location.href = data;
        } else if (returnCode !== '200') {
          Toast(returnMessage);
        }
      } catch (e) {
        Toast('操作失败');
      }
    },
    // 授信合同初始化
    contCreditGenerateSpdb(context) {
      const { orderId } = context.state;
      const data = service.OtherPage.contCreditGenerateSpdb({
        orderId,
      });
      data
        .then((res) => {
          if (res.success) {
            context.commit('updateForm', {
              creditContractObj: res.data,
            });
          } else {
            Toast(res.returnMessage);
          }
        })
        .catch(() => {
          Toast('小望已离开地球，请稍后重试！');
        });
    },
    // 签署授信合同
    signCreditGenerateSpdb(context) {
      const { orderId } = context.state;
      const data = service.OtherPage.signCreditGenerateSpdb({
        orderId,
      });
      data
        .then((res) => {
          if (res.success) {
            context.dispatch('nextJumpPage', { context });
          } else if (res.returnCode === 'EDC0002') {
            Dialog.confirm({
              title: '提示',
              message: res.returnMessage,
              confirmButtonText: '确认',
              cancelButtonText: '取消',
            }).then(() => {
              // on confirm
              service.CommonForms.jumpThirdServer({ orderId }).then(
                // eslint-disable-next-line no-shadow
                (res) => {
                  if (res.success) {
                    if (res.data) {
                      window.location.href = res.data;
                    }
                  } else {
                    Toast(res.returnMessage);
                  }
                },
              );
            });
          } else {
            Toast(res.returnMessage);
          }
        })
        .catch(() => {
          Toast('小望已离开地球，请稍后重试！');
        });
    },
    // 添加银行卡号
    // eslint-disable-next-line consistent-return
    addFillCardNumber(context, play) {
      const { bankCard } = context.state;
      const { orderId } = play;
      const reg = /^[0-9]\d{8,30}$/;
      if (!reg.test(bankCard)) return Toast('请输入正确的银行卡号');
      const data = service.OtherPage.addFillCardNumber({
        orderId,
        bankCard,
      });
      data
        .then((res) => {
          if (res.success) {
            context.dispatch('nextJumpPage', { context });
          } else {
            Toast(res.returnMessage);
          }
        })
        .catch(() => {
          Toast('小望已离开地球，请稍后重试！');
        });
    },
    // 提款成功
    getBorrowerinfo(context) {
      const { orderId } = context.state;
      const data = service.OtherPage.getBorrowerinfo({
        orderId,
      });
      data
        .then((res) => {
          if (res.success) {
            context.commit('updateForm', {
              getBorrowerinfoObj: res.data,
            });
          } else {
            Toast(res.returnMessage);
          }
        })
        .catch(() => {
          Toast('小望已离开地球，请稍后重试！');
        });
    },
    // 还款试算
    addOkCalculation(context) {
      const { amount, drawId, orderId } = context.state;
      const data = service.OtherPage.addOkCalculation({
        orderId,
        amount,
        drawId,
      });
      data
        .then((res) => {
          if (res.success) {
            context.commit('updateForm', {
              addOkCalculationObj: res.data,
              isBtn: true,
            });
          } else {
            Toast(res.returnMessage);
          }
        })
        .catch(() => {
          Toast('小望已离开地球，请稍后重试！');
        });
    },
    // 提交还款试算
    prepayment(context) {
      const { amount, drawId, orderId } = context.state;
      const data = service.OtherPage.prepayment({
        orderId,
        amount,
        drawId,
      });
      data
        .then((res) => {
          if (res.success) {
            router.push('/supermarket/v2/repaymentSuccessful');
          } else {
            Toast(res.returnMessage);
          }
        })
        .catch(() => {
          Toast('小望已离开地球，请稍后重试！');
        });
    },
  },
  getters: {},
};
